module.exports = __webpack_public_path__ + "assets/img/CX.1ac0ca4a.png";